import React, { Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { LayoutSplashScreen } from "../../../_metronic";

const ContratoPage = lazy(() => import("./contrato/ContratoPage"));
const EventoPage = lazy(() => import("./evento/EventoPage"));
const FaturaPage = lazy(() => import("./fatura/FaturaPage"));
const RelatorioPage = lazy(() => import("./relatorio/RelatorioPage"));
const DashboardPage = lazy(() => import("./dashboard/DashboardPage"));

export default function HomePage() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                <Redirect exact from="/" to="/dashboard" />

                <Route path="/dashboard" component={DashboardPage} />
                <Route path="/contrato" component={ContratoPage} />
                <Route path="/evento" component={EventoPage} />
                <Route path="/fatura" component={FaturaPage} />
                <Route path="/relatorio" component={RelatorioPage} />

                <Redirect to="/error/error-v6" />
            </Switch>
        </Suspense>
    );
}
